<template>
    <div>
        <datatable :columns="columns" :source="getRecords" @selected="recordSelected"></datatable>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"

    export default  {

        data: function () {
            return {
                columns: [
                    { name: "Name", data: "name" },
                    {
                        name: "Is Active",
                        data: "active",
                        render: function (data, type, row) {
                            return data ? "Active" : "Disabled"
                        }
                    },
                    {
                        name: "Status From",
                        data: "statusFrom",
                        render: Formatter.FormatDate
                    },
                    {
                        name: "Electronic Recording",
                        data: "electronicReorderingEnabled",
                        render: function (data, type, row) {
                            return data ? "Enabled" : "Disabled"
                        }
                    },
                    {
                        name: "Created",
                        data: "whenCreated",
                        render: Formatter.FormatDate
                    }
                ]
            }
        },
        methods: {

            getRecords: function (callback) {

                var dal = new Dal();

                dal.GetCarehomes().then(data => {
                    var records = { data: data };
                    callback(records);
                });
            },

            recordSelected: function (record) {
                var id = record.id;
                this.$router.push({ name: 'pharmacy-carehome-users', params: { carehomeid : id } })
            }
        },
        components: {
            datatable
        }
    }
</script>


// WEBPACK FOOTER //
// carehome-list.scp.html?a99e2324